<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('wordSeparator.page.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('wordSeparator.page.title') }}
        </h3>
      </d-col>
    </d-row>
    <!-- Content -->
    <d-row>
      <d-col cols="12" class="col-md">
        <d-card class="mb-4 card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="6">
                <h6 class="m-0">
                  {{ $t('wordSeparator.card.title') }}
                </h6>
              </d-col>
            </d-row>
          </d-card-header>

          <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <word-separator-form ref="wordSeparatorFormRef" />
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import WordSeparatorForm from '../components/WordSeparatorForm.vue';

export default {
  name: 'generate-page',
  components: {
    WordSeparatorForm,
  },
};
</script>
